<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Heads up!</h1>
        </template>
        
        <p>Mailman enables you to allow/block precisely who has access to your inbox.</p>

        <span class="my-2 block border-t border-gray-dark"></span>

        <img src="/images/tutorials/inspect-actions.png" alt="Tutorial of inspect actions" class="md:w-2/3 mx-auto">

        <span class="my-2 block border-t border-gray-dark"></span>

        <p class="text-sm text-gray-darker italic">This message will not be shown again.</p>

        <template v-slot:footer>
            <button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                @click.prevent="submit"
            >
                Got it!
            </button>
        </template>
    </modal-component>
</template>

<script>
export default {
    methods: {
        submit() {
            this.$emit('resolve');
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>